import type { MaybeRefOrGetter } from 'vue';
import type { GlobalSingleRelationFieldId } from '#layers/data-model';
import { computed, toValue } from 'vue';
import { useProjectSchemaStore } from '~/stores/project-schema';

export function useSingleRelationField(fieldId: MaybeRefOrGetter<GlobalSingleRelationFieldId | null | undefined>) {
	const { findSingleRelationFieldById } = useProjectSchemaStore();
	return computed(() => {
		const fieldIdValue = toValue(fieldId);
		return fieldIdValue ? findSingleRelationFieldById(fieldIdValue) : undefined;
	});
}
